
<!--
<app-fields-interventions-tractors-trailer-width-choice-report
  *ngIf="currentReportType.value === 'tractors-trailer-width-choice'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-tractors-trailer-width-choice-report>
-->
<div [hidden]="!reportCurrentViewModes.includes('pivot')">
  <dx-pivot-grid [allowSortingBySummary]="true"
                 [allowSorting]="true"
                 [allowFiltering]="true"
                 [width]="width"
                 [allowExpandAll]="true"
                 [showBorders]="false"
                 [showColumnGrandTotals]="false">
    <dxo-header-filter
      [allowSearch]="true"
      [showRelevantValues]="true"
    ></dxo-header-filter>
    <dxo-field-chooser applyChangesMode="onDemand" [enabled]="true"></dxo-field-chooser>
    <dxo-export [enabled]="true" [fileName]="currentReportType.label"></dxo-export>

    <dxo-field-panel
      [showColumnFields]="false"
      [showRowFields]="false"
      [showDataFields]="false"
      [visible]="true">
    </dxo-field-panel>
  </dx-pivot-grid>
</div>

<div class="p-4" [hidden]="!reportCurrentViewModes.includes('chart')">
  <div class=" flex items-center justify-center">
    <dx-chart class="self-center">

    <dxo-title horizontalAlignment="center" [text]="currentReportType.label" verticalAlignment="top">
      <dxo-font [weight]="300" [size]="20"></dxo-font>
    </dxo-title>

    <dxo-legend
      verticalAlignment="bottom"
      horizontalAlignment="center"
      itemTextPosition="right">
    </dxo-legend>

    <dxo-common-axis-settings>
      <dxo-grid [visible]="true"></dxo-grid>
    </dxo-common-axis-settings>

    <dxo-export [enabled]="true"></dxo-export>

    <dxo-zoom-and-pan
      [dragToZoom]="true"
      valueAxis="none"
      argumentAxis="both"
    ></dxo-zoom-and-pan>

    <dxo-tooltip
      [enabled]="true"
      [customizeTooltip]="customizeTooltip">
    </dxo-tooltip>

      <dxo-common-series-settings type="bar"></dxo-common-series-settings>
      <dxo-size [height]="450" [width]="width*0.6"></dxo-size>
    </dx-chart>
  </div>
</div>

